module.exports = __webpack_public_path__ + "img/sk-img01.121447dd.png";